var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mr-1",attrs:{"native-type":"submit","type":"is-primary","icon-left":"search","size":"is-small"}},[_vm._t("default",function(){return [_vm._v("Buscar")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }